import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function() {
	$('.slider--partenaires').slick({
	  autoplay: true,
	  autoplaySpeed: 3000,
	  arrows: true,
	  dots: false,
	  infinite: true,
	  speed: 300,
	  slidesToShow: 4,
	  slidesToScroll: 4,
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        infinite: true,
	        dots: true
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	  ]
	});
	
	$('.slider--temoignages').slick({
	  autoplay: true,
	  autoplaySpeed: 3000,
	  arrows: true,
	  dots: false,
	  infinite: true,
	  speed: 300
	});	
	
	$('.slider--galerie').slick({
	  autoplay: true,
	  autoplaySpeed: 3000,
	  arrows: true,
	  dots: false,
	  infinite: true,
	  speed: 300,
	  slidesToShow: 3,
	  slidesToScroll: 3,
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2,
	        infinite: true
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
				dots: false,
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
				dots: true,
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	  ]
	});

});